export const vinculos = [
  {id: 1, nome: 'Comunicante'},
  {id: 2, nome: 'Proprietário'},
  {id: 3, nome: 'Financeira'},
  {id: 4, nome: 'Financeira/Arrendamento'},
  {id: 5, nome: 'Comunicante de Venda'},
  {id: 6, nome: 'Seguradora'},
  {id: 7, nome: 'Locadora'}
]

export const origens = [
  {id: 1, nome: 'Ativo (Telefone)'},
  {id: 2, nome: 'E-mail'},
  {id: 3, nome: 'Presencial'},
  {id: 4, nome: 'Receptivo (Telefone)'},
  {id: 5, nome: 'Reintegração Cevera'},
  {id: 6, nome: 'Web'}
]



// WEBPACK FOOTER //
// ./src/domain/grv/helpers/helpers-notificacao.js